import { api } from "../../../../../services/api";

export async function getCounty(uf) {
  const state = uf.split("-")[0];
  const municipio = await api.get("/getMunicipio", {
    params: { idEstado: state },
  });
  return municipio.data.recordset;
}
